import { defineStore } from 'pinia'

export const usePreferenceStore = defineStore('preferenceStore', {
  state: (): {
    hasFitbike: boolean
    hasPositioningMotors: boolean
    hasXYTool: boolean
    has3DMotionAnalyzer: boolean
    has3DPedallingAnalyzer: boolean
    hasHeartRateMonitor: boolean
  } => ({
    hasFitbike: true,
    hasPositioningMotors: true,
    hasXYTool: true,
    has3DMotionAnalyzer: false,
    has3DPedallingAnalyzer: false,
    hasHeartRateMonitor: true,
  }),
  getters: {},
  actions: {},
  persist: true,
})
